export const BOX_KM_EXPLORER_OPEN = 'w:BoxExplorerComponent:view';

export const BOX_KM_PREVIEW_OPEN = 'w:BoxPreviewComponent:view';
